import { getKey as sharedGetKey } from '@upstart/shared-api-utils';

type ParamsObj = Record<any, any>;

export enum Resource {
  SOFT_CREDIT_PULL_REPORT = '/softcreditpull/:dealId/credit-report',
  DEALER_SETUP_FEATURE_CONFIGS = 'dealer-setup-feature-configs',
  DEALER_DELETED_LIST = 'dealer-deleted-list',
  CRM_MERGE_LEADS_OPERATIONS = 'crm-merge-leads-operations',
  RIC_STATE_SCHEMAS = 'ric-state-schemas',
  RIC_STATE_SCHEMA = 'ric-state-schema',
  RIC_STATE_SCHEMA_REVISIONS = 'ric-state-schema-revisions',
}

export type ApiCacheKey<P extends ParamsObj> = {
  resource: Resource;
  params: P;
};

export const getKey = <P extends ParamsObj>(
  resource: Resource,
  params: P,
): ApiCacheKey<P> => sharedGetKey('chairman', resource, params);
